import styled from 'styled-components';

export const HoverIcon = styled.div`
	opacity: 0.3;
	&:hover {
		opacity: 1;
	}
`;

export const StyledLink = styled.div`
	cursor: pointer;
	&:hover {
		text-decoration: underline;
		color: ${props => props.theme.palette.secondary.main};
	}
`;

export const Padded = styled.div`
	padding: 1rem;
`;

export const PaddedY = styled.div`
	padding: 1rem 0rem;
`;
export const PaddedX = styled.div`
	padding: 0rem 1rem;
`;

export const PaddedLarge = styled.div`
	padding: 2rem;
`;

export const HalfPadded = styled.div`
	padding: 0.5rem;
`;
export const HalfPaddedY = styled.div`
	padding: 0.5rem 0;
`;

export const PaddedLargeSide = styled.div`
	padding: 1rem 2rem;
`;
